import { Droppable } from "@hello-pangea/dnd";

export default function AddRowWithColumn(props) {
  return (
    <Droppable
      key={`addRowWithColumn-${props.count}`}
      droppableId={`addRowWithColumn-${props.count}`}
      direction="vertical"
      type={"column"}
    >
      {(provided, snapshot) => {
        return (
          <div
            ref={provided.innerRef}
            className={`plusRowWithColumn ${snapshot.isDraggingOver ? "draggingOver" : ""
              }`}
            {...provided.droppableProps}
          >
            {props.buildArea.length === 0 ? (
              <div className="text">
                <h2>UI SCHÉMA</h2>
                <p>pretiahnite alebo pridajte komponent</p>
                <h4>+</h4>
              </div>
            ) : (
              <div>+</div>
            )}
          </div>
        );
      }}
    </Droppable>
  );
}
